/* ==========================================================================
   OUTLYRS CLUB — predictive-search.js
   Minimal inline header search. The field expands beside the search icon on
   click/focus and submits to the native Shopify search results on Enter.
   No modal, no drawer, no dropdown.
   ========================================================================== */
(function () {
  "use strict";

  var form = document.querySelector("[data-header-search]");
  if (!form) return;
  var toggle = form.querySelector("[data-search-toggle]");
  var field = form.querySelector("[data-search-field]");
  if (!toggle || !field) return;

  function open() {
    form.classList.add("is-open");
    toggle.setAttribute("aria-expanded", "true");
    field.removeAttribute("tabindex");
    field.focus();
  }
  function close() {
    form.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
    field.setAttribute("tabindex", "-1");
  }

  toggle.addEventListener("click", function () {
    if (form.classList.contains("is-open")) {
      // Open with a query → submit; open but empty → collapse.
      if (field.value.trim()) form.submit();
      else close();
    } else {
      open();
    }
  });

  field.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { close(); toggle.focus(); }
  });

  // Collapse when focus/click leaves the search, unless a query is typed.
  document.addEventListener("click", function (e) {
    if (!form.contains(e.target) && form.classList.contains("is-open") && !field.value.trim()) {
      close();
    }
  });
})();
